const EMPTY_ARRAY = Object.freeze([]);

export const asArray = (value) => Array.isArray(value) ? value : EMPTY_ARRAY;

export const asObject = (value) => (
    value && typeof value === 'object' && !Array.isArray(value) ? value : {}
);

export const asString = (value, fallback = '') => (
    value == null ? fallback : String(value)
);

export const splitString = (value, delimiter, fallback = []) => {
    const text = asString(value).trim();
    if (!text) {
        return fallback;
    }
    return text.split(delimiter).map(item => item.trim()).filter(Boolean);
};
